import { Box, Button, TextField, Typography, useMediaQuery, useTheme } from "@mui/material"
import { useState } from "react"

const TextFieldPattern = ({ label, ...props }) => {
    return (
        <TextField
            variant="standard"
            sx={{
                '& .MuiInputLabel-root': {
                    marginBottom: '2em',
                },
                '& .MuiInput-root': {
                    marginTop: '2em',
                },
                maxWidth: '37em'
            }}
            InputLabelProps={{
                shrink: true,
                sx: {
                    '&.MuiInputLabel-root': {
                        fontSize: 18,
                    },
                },
            }}
            label={
                <Typography variant="h6">
                    {label}
                </Typography>
            }
            {...props}
        />
    )
}

export default function Contact() {
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down('sm'))
    const mobile2 = useMediaQuery('(max-width:768px)');
    const mobileWidth = window.innerWidth <= 768
    const isMobile = window.cordova || mobileWidth || mobile || mobile2

    const [userEmail, setUserEmail] = useState("")
    const [msg, setMsg] = useState("")
    const [sub, setSub] = useState("")

    const handleSendEmail = () => {
        const email = 'contato@tch.agr.br'
        const subject = sub
        const body = msg

        window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}&cc=${encodeURIComponent(userEmail)}`;
    };

    return (
        <div>
            <Typography
                sx={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    paddingTop: isMobile ? '1em' : '1.5em',
                }}
                variant="h4"
            >
                <b>Contato</b>
            </Typography>
            <Box
                sx={{
                    flex: 1,
                    paddingTop: isMobile ? '0.5em' : '1.5em',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'center' : 'flex-start',
                    justifyContent: isMobile ? 'center' : 'space-around',
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: isMobile ? 'center' : 'flex-end',
                        height: '100vh',
                        padding: '1em',
                    }}
                >
                    <Box
                        sx={{
                            padding: '1em',
                            textAlign: isMobile ? 'center' : 'right',
                        }}
                    >
                        <Typography
                            sx={{
                                color: '#c71e25',
                                fontWeight: 'bold',
                                marginBottom: '0.5em',
                            }}
                            variant="h5"
                        >
                            Entre em contato com a
                            <br />
                            TCH Gestão Agrícola:
                        </Typography>
                        <Typography
                            sx={{
                                color: '#c71e25',
                                fontWeight: 'bold',
                                marginBottom: '0.5em',
                            }}
                            variant="h6"
                        >
                            (67) 9245-5599
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: 'bold',
                            }}
                        >
                            contato@tch.agr.br
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4, p: 1, marginTop: isMobile ? '1em' : '2em', width: '100%' }}>
                    <TextFieldPattern label={"Seu nome (obrigatório) *"} />
                    <TextFieldPattern label={"Seu e-mail (obrigatório) *"} value={userEmail} onChange={(e) => setUserEmail(e.target.value)} />
                    <TextFieldPattern label={"Assunto"} value={sub} onChange={(e) => setSub(e.target.value)} />
                    <TextFieldPattern label={"Sua mensagem"} value={msg} onChange={(e) => setMsg(e.target.value)} multiline />
                    <Box sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start', marginTop: isMobile ? '1em' : '2em' }}>
                        <Button variant="contained" color="primary" onClick={handleSendEmail}>
                            Enviar
                        </Button>
                    </Box>
                </Box>
            </Box>
        </div>
    )
}
